import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import type {ListSchemaResponse} from 'nutshell-core/schema/schema-types';
import type {ReportRowData, TimeseriesReportData, ListItem} from 'nutshell-core/types';

import * as actions from './forms-actions';
import type {FormsAction} from './forms-types';

type SchemaState = ListSchemaResponse | null | undefined;

type FormSubmissionsListState = {
    isLoading: boolean;
    isFirstLoad: boolean;
    errorMessage?: string;
    listItems: any[];
    meta: any;
};

const formSubmissionsListDefaultState = {
    isLoading: true,
    isFirstLoad: true,
    errorMessage: undefined,
    listItems: [],
    meta: {},
} as const;

const isFilterDrawerOpen = createReducer(
    {
        // @ts-expect-error
        [actions.toggleShowFilterDrawer]: (state) => !state,
    },
    false
);

export const formSubmissionsListReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestFormSubmissionsListData]: (state) => {
            return {...state, isLoading: true, errorMessage: undefined};
        },
        // @ts-expect-error
        [actions.updateFormSubmissionsListData]: (state, {meta, listItems}) => {
            return {
                ...state,
                isLoading: false,
                isFirstLoad: false,
                meta: meta,
                listItems: listItems
                    ? listItems.map((item: ListItem) => {
                          return {
                              ...item,
                              id: item.links ? item.links.entity.id : item.id,
                          };
                      })
                    : undefined,
                errorMessage: undefined,
            };
        },
        // @ts-expect-error
        [actions.failFormSubmissionsListData]: (state, err) => {
            return {...state, isLoading: false, isFirstLoad: false, errorMessage: err};
        },
    },
    formSubmissionsListDefaultState
);

type FormEngagementReportTableData = {
    rows: ReportRowData[] | null | undefined;
    totals: ReportRowData | null | undefined;
};
type FormEngagementReportState = {
    timeseriesChart: {
        isLoading: boolean;
        isTimedOut: boolean;
        isErrored: boolean;
        chartData: TimeseriesReportData | null | undefined;
        prefix: string;
    };
};
const formEngagementReportDefaultState = {
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
} as const;

const formEngagementReportReducer = createReducer(
    {
        [actions.updateFormEngagementReportTableData]: (
            // @ts-expect-error
            state,
            payload: FormEngagementReportTableData
        ) => {
            return {...state, tableData: payload};
        },
        // @ts-expect-error
        [actions.requestFormEngagementReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.updateFormEngagementReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.failFormEngagementReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                }
            }

            return state;
        },
    },
    formEngagementReportDefaultState
);

const schemaReducer = (
    state: SchemaState | null | undefined = null,
    action: FormsAction
): SchemaState => {
    switch (action.type) {
        case 'FORMS_SCHEMA_UPDATED':
            return action.payload;
        default:
            return state;
    }
};

export const webFormsReducer = combineReducers({
    formSubmissionsList: formSubmissionsListReducer,
    formEngagementReport: formEngagementReportReducer,
    formSchema: schemaReducer,
    isFilterDrawerOpen,
});

export type WebFormsState = {
    formSubmissionsList: FormSubmissionsListState;
    formEngagementReport: FormEngagementReportState;
    formSchema: SchemaState;
    isFilterDrawerOpen: boolean;
};
